// disabling multiple linting rules on import because of unholy business beyond
// eslint comprehension
/* eslint-disable import/export */
/* eslint-disable import/no-duplicates */

//@ts-expect-error: declaration types should not be imported, but we do need it
//for our shenanigans with styled
import * as typeStyled from "@types/styled-components"
import * as implementationStyled from "../node_modules/styled-components"

//@ts-expect-error: declaration types should not be imported, but we do need it
//for our shenanigans with styled
export type * from "@types/styled-components"

const styled = implementationStyled.styled as unknown as typeStyled.StyledInterface

export const css = implementationStyled.css as unknown as typeof typeStyled.css

export const keyframes = implementationStyled.keyframes as unknown as typeof typeStyled.keyframes

export const createGlobalStyle = implementationStyled.createGlobalStyle as unknown as typeof typeStyled.createGlobalStyle

export const ServerStyleSheet = implementationStyled.ServerStyleSheet as unknown as typeof typeStyled.ServerStyleSheet

export const ThemeContext = implementationStyled.ThemeContext as unknown as typeof typeStyled.ThemeContext

export const ThemeProvider = implementationStyled.ThemeProvider as unknown as typeof typeStyled.ThemeProvider

export default styled
